import { Pipe, PipeTransform } from '@angular/core';
import { DistanceType } from '@models/measurements';
import { MeasurementUtils } from '@utilities/measurement-utils';


@Pipe({
    name: 'distanceConverter'
})
export class DistanceConversionPipe implements PipeTransform {

    constructor(
    ) { }

    transform(value: number, ...args: DistanceType[]): number {
        return MeasurementUtils.convert(value, args[0], args[1]);
    }

}
